import Dexie from "dexie";

const db = new Dexie("StoreDatabase");

db.version(1).stores({
  catalog: "key",
});

const CATALOG_KEY = "catalog_snapshot";

export async function saveCatalog(data) {
  await db.catalog.put({
    key: CATALOG_KEY,
    data,
    fetchedAt: new Date().toISOString(),
  });
}

export async function getCatalog() {
  return db.catalog.get(CATALOG_KEY);
}

export async function deleteCatalog() {
  await db.catalog.delete(CATALOG_KEY);
}